export default __webpack_public_path__ + "static/media/blob.right-md.4d10714e.png";